<template>
  <table class="table table-borderless w-auto m-auto align-middle">
    <tbody class="text-end">
      <tr>
        <td>Height:</td>
        <td>
          <div class="input-group flex-nowrap">
            <input
              class="form-control"
              style="width: 100px"
              type="number"
              min="10"
              step="10"
              v-model="controlStore.defaultValveHeight"
            />
            <span class="input-group-text">µm</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>Length:</td>
        <td>
          <div class="input-group flex-nowrap">
            <input
              class="form-control"
              style="width: 100px"
              type="number"
              min="10"
              step="10"
              v-model="controlStore.defaultValveLength"
            />
            <span class="input-group-text">µm</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>Width:</td>
        <td>
          <div class="input-group flex-nowrap">
            <input
              class="form-control"
              style="width: 100px"
              type="number"
              min="10"
              step="10"
              v-model="controlStore.defaultValveWidth"
            />
            <span class="input-group-text">µm</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>Radius:</td>
        <td>
          <div class="input-group flex-nowrap">
            <input
              class="form-control"
              style="width: 100px"
              type="number"
              min="10"
              step="10"
              v-model="controlStore.defaultValveRoundedRadius"
            />
            <span class="input-group-text">µm</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { useControlStore } from "@/stores/control";
import { defineComponent } from "vue";
import { Mode } from "@/library/other";
import { Valve } from "@/library/valve";

export default defineComponent({
  setup() {
    const controlStore = useControlStore();

    return { controlStore, Mode, Valve };
  },
});
</script>
